import React, { useState } from "react";
import { motion } from "framer-motion";
import { CheckIcon } from "lucide-react";
import { volumeGroups } from "../data/landing";
import { SegmentedControl } from "./SegmentedControl";
type Season = "Halloween" | "Navidad" | "Año Nuevo";
const seasonStyles: Record<string, string> = {
  Halloween: "bg-[#2A1C14] text-[#F0B36A]",
  Navidad: "bg-wine text-goldSoft",
  "Año Nuevo": "bg-forestDeep text-goldSoft"
};
export function Volumes() {
  const [season, setSeason] = useState<Season>("Halloween");
  return <section id="contenido" className="bg-paper" data-id="element-320" data-mp="24suoxrbxvdhf">
      <div className="mx-auto max-w-6xl px-5 py-12 md:px-8 md:py-24" data-id="element-321" data-mp="1qumze4h8fega">
        <div className="max-w-2xl" data-id="element-322" data-mp="1qwhays6m5u7p">
          <p className="text-sm font-semibold text-wine" data-id="element-323" data-mp="1vsy98f7j1oyi">Contenido completo · Los 6 tomos principales</p>
          <h2 className="mt-2 font-display text-[28px] leading-tight text-forest md:mt-3 md:text-5xl" data-id="element-324" data-mp="feokhjzdhy75">
            Tu hoja de ruta para brillar en cada festejo del último trimestre
          </h2>
        </div>
        <SegmentedControl<Season> label="Elegí una festividad" className="mt-6 lg:hidden" value={season} onChange={setSeason} options={volumeGroups.map(g => ({
        value: g.season as Season,
        label: g.season
      }))} data-id="element-325" data-mp="3o7df9a1k10px" />
        <div className="mt-4 grid gap-6 lg:mt-14 lg:grid-cols-3" data-id="element-326" data-mp="3t79kfclzmy72">
          {volumeGroups.map(g => {
          const active = g.season === season;
          return <motion.article key={g.season} initial={false} animate={{
            opacity: 1
          }} className={`${active ? "flex" : "hidden"} flex-col overflow-hidden rounded-2xl ring-1 ring-line lg:flex`} data-id="element-327" data-mp="azk0r8apr6ex">
                <header className={`flex items-baseline justify-between px-5 py-3.5 md:block md:px-6 md:py-5 ${seasonStyles[g.season]}`} data-id="element-328" data-mp="fsvbhkinc7c4">
                  <h3 className="font-display text-2xl md:text-3xl" data-id="element-329" data-mp="pqj70co2tivc">{g.season}</h3>
                  <p className="text-xs opacity-80 md:text-sm" data-id="element-330" data-mp="pog8f48uyhf0">{g.month}</p>
                </header>
                <div className="flex flex-1 flex-col divide-y divide-line bg-paper" data-id="element-331" data-mp="wrmrlv7ud1of">
                  {g.volumes.map(v => <div key={v.code} className="flex-1 p-4 md:p-6" data-id="element-332" data-mp="16s6v74iu2i9t">
                      <p className="text-[11px] font-bold tracking-widest text-gold md:text-xs" data-id="element-333" data-mp="16pu5g56u33m7">TOMO {v.code.slice(1)}</p>
                      <h4 className="mt-0.5 font-display text-xl leading-tight text-forest md:mt-1 md:text-2xl" data-id="element-334" data-mp="1fkh7crdagxtp">{v.title}</h4>
                      <p className="mt-0.5 text-[13px] font-medium italic text-wine md:mt-1 md:text-sm" data-id="element-335" data-mp="1kiip98yzar3l">{v.subtitle}</p>
                      <p className="mt-2 text-sm leading-relaxed text-muted md:mt-3 md:text-[15px]" data-id="element-336" data-mp="1pjpup1dnfe73">{v.text}</p>
                      {v.bullets.length > 0 && <ul className="mt-3 space-y-1.5 md:mt-4 md:space-y-2" data-id="element-337" data-mp="3rab3mei3xmcc">
                          {v.bullets.map(b => <li key={b} className="flex gap-2 text-[13px] text-ink md:text-sm" data-id="element-338" data-mp="49r01ihukol">
                              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest" aria-hidden data-id="element-339" data-mp="2dejl84vemo3x" />
                              {b}
                            </li>)}
                        </ul>}
                    </div>)}
                </div>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}